import React, { useRef, useEffect, useState } from "react";
import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/lab";
import { useFormContext } from "react-hook-form";
import moment from "moment";

import { useSharedBookReducer } from "../state";

const SurfDatesAndTimes = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, setValue } = useFormContext();

  const [openDatePicker, setOpenDatePicker] = useState(false);

  const setDays = (e) => {
    setValue("days", e.target.value);
    dispatch({
      type: "MERGE",
      payload: {
        m: { days: e.target.value },
      },
    });
  };

  const setStartDate = (val) => {
    setValue("start_date", val.format("YYYY-MM-DD"));
    dispatch({
      type: "MERGE",
      payload: {
        m: { start_date: val.format("YYYY-MM-DD") },
      },
    });
  };

  const setTime = (e) => {
    // console.log("e:", v);
    // e.target.blur();
    setTimeout(() => document.activeElement.blur(), 1);
    setValue("time", e.target.value);
    dispatch({
      type: "MERGE",
      payload: {
        m: { time: e.target.value },
      },
    });
  };

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Surf Dates and Times
      </Typography>

      <input
        {...register("days", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.days}
      />
      <input
        {...register("start_date", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.start_date}
      />
      <input
        {...register("time", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.time}
      />

      <Grid container spacing={3}>
        <Grid item md={5} xs={12}>
          <FormControl sx={{ m: 1, minWidth: 120 }} fullWidth>
            <Select value={bookState.m.days} onChange={setDays}>
              <MenuItem value="1">Single Day</MenuItem>
              <MenuItem value="2">2 Days</MenuItem>
              <MenuItem value="3">3 Days</MenuItem>
              <MenuItem value="4">4 Days</MenuItem>
              <MenuItem value="5">5 Days</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={7} xs={12}>
          <DatePicker
            open={openDatePicker}
            onClose={() => setOpenDatePicker(false)}
            label="Start Date"
            value={bookState.m.start_date}
            onChange={setStartDate}
            renderInput={(params) => (
              <TextField
                fullWidth
                {...params}
                onClick={() => setOpenDatePicker(true)}
              />
            )}
            inputFormat={"dddd, MMMM Do YYYY"}
            // mask={"dddd, MMMM Do YYYY"}
            mask={null}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item md={5} xs={12}>
          <FormControl sx={{ m: 1, minWidth: 120 }} fullWidth>
            <Select value={bookState.m.time} onChange={setTime}>
              <MenuItem value="instructor_recommended">
                Instructor Recommended Time
              </MenuItem>
              <MenuItem value="morning">Morning</MenuItem>
              <MenuItem value="afternoon">Afternoon</MenuItem>
              <MenuItem value="evening">Evening</MenuItem>
              <MenuItem value="other_time">Custom</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {bookState.m.time === "other_time" ? (
          <Grid item md={7} xs={12}>
            <OtherTimeEntry />
          </Grid>
        ) : null}
      </Grid>

      {/* 
								<div class="field is-horizontal" v-if="showDayCounter">
									<div class="field-body">
										<div class="control is-expanded has-icons-left">
											<div class="select is-fullwidth">
												<select name="days" v-model="m.days">
													<option value="1">Single Day</option>
													<option value="2">2 Days (${{kv 'price.multi-day-discount'}}/day discount)</option>
													<option value="3">3 Days (${{kv 'price.multi-day-discount'}}/day discount)</option>
													<option value="4">4 Days (${{kv 'price.multi-day-discount'}}/day discount)</option>
													<option value="5">5 Days (${{kv 'price.multi-day-discount'}}/day discount)</option>
												</select>
											</div>
											<span class="icon is-small is-left">
												<i class="fas fa-calendar-day"></i>
											</span>
										</div>
									</div>
								</div>


								<div class="field" v-if="showCalendar">
									<div class="field-body">
										<div class="field">
											<label class="label" v-if="m.days != '1'">
												Please choose the start date for your multi-day lesson
											</label>
											<div class="control has-icons-left">
												<datepicker ref="inputDateStart" type="text" size="15" class="pickDate start-date dp-applied"
													id="TemplateStartDateNice" :format="prettyDateFormat" input-class="input"
													v-on:selected="updateHiddenDate($event, 'hiddenDateStart')"></datepicker>
												<input name="start_date" type="hidden" ref="hiddenDateStart"
													data-date-input-link="inputDateStart" value="" />
												<span class="icon is-small is-left">
													<i class="fas fa-calendar-alt"></i>
												</span>
											</div>
										</div>
									</div>
								</div>

								<div class="field is-horizontal" v-if="showRecTimes">
									<div class="field-body">
										<div class="control is-expanded has-icons-left">
											<div class="select is-fullwidth">
												<select name="time" v-model="m.time">
													<option value="instructor_recommended">Instructor Recommended Time</option>
													<option value="morning">Morning</option>
													<option value="afternoon">Afternoon</option>
													<option value="time_other">Custom</option>
												</select>
											</div>
											<span class="icon is-small is-left">
												<i class="fas fa-clock"></i>
											</span>
										</div>
									</div>
								</div>

								<div class="field is-horizontal" v-if="showRecTimes && m.time == 'time_other'">
									<div class="field-body">
										<div class="field is-expanded">
											<div class="control has-icons-left">
												<input class="input" type="text" placeholder="Please enter a specific time" name="time_other"
													v-model="m.time_other">
												<span class="icon is-small is-left">
													<i class="fas fa-clock"></i>
												</span>
											</div>
											<p class="help is-default">
												Please allow 48 hours for time confirmation
											</p>
										</div>
									</div>
      </div> */}
    </>
  );
};

const OtherTimeEntry = () => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, setValue } = useFormContext();

  const handleChangeCustom = (e) => {
    setValue("time_other", e.target.value);
    dispatch({
      type: "MERGE",
      payload: {
        m: { time_other: e.target.value },
      },
    });
  };
  const ref = useRef();

  useEffect(() => {
    setTimeout(() => {
      console.log("ref:", ref.current);
      ref?.current?.focus();
    }, 1);
  }, []);

  return (
    <div>
      <input
        {...register("time_other", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.time_other}
      />
      <TextField
        inputRef={ref}
        autoFocus
        placeholder="Please enter a specific time"
        value={bookState.m.time_other}
        onChange={handleChangeCustom}
        helperText="Please allow 48 hours for time confirmation"
      />
    </div>
  );
};

export default SurfDatesAndTimes;
